module.exports = __webpack_public_path__ + "static/media/hotel_f6_v2.0d874c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/hotel_f6_v2.png
// module id = 322
// module chunks = 0